import { zoidCreate } from "../zoidComponent";
import v4 from "uuid/v4";
import { Utils } from "../utils";
import { createLogger } from "@888webteam/logger-core";


export class BaseComponent {

    constructor(settings, mode) {

        this.logger = createLogger("BaseComponent");

        settings = settings || {};
        settings.context = settings.context || {};
        settings.context.mode = mode;
        settings.events = settings.events || {};

        this._callbacks = null;

        settings.events.internalOnLoad = function (callbacks) {

            this._callbacks = callbacks;

            if (typeof this._settings.events === "object" &&
                typeof this._settings.events.onLoad === "function") {

                this._settings.events.onLoad();
            }

        }.bind(this);

        if (Utils.isBankIdJsExecutedInIframe === false) {
            settings.events.openBankId = (url, autoStartToken) => {
                try {
                    this.logger.log(`Calling BankId with URL: '${url}'`);
                    if (Utils.isFirefox === false) {
                        window.location.assign(url);
                    } else {
                        const tab = window.open(url);
                        tab && tab.close();
                    }
                    
                } catch (err) {
                    this.logger.error(err);
                }
            }
        }

        if (typeof settings.context.sessionId === "undefined") {
            settings.context.sessionId = v4();
        }

        this._settings = settings;
    }

    render(selector) {
        this.renderZoid(selector);

        return this;
    }

    renderZoid(selector) {
        let zoidComponent = zoidCreate(this._settings.context);

        zoidComponent({
            settings: this._settings
        }).render(selector);
    }

    reset() {

        if (this._callbacks !== null) {
            this._callbacks.reset();
        }
    }

    showError(err) {
        if (this._callbacks !== null) {
            this._callbacks.showError(err);
        }
    }

    showGeneralError() {
        if (this._callbacks !== null) {
            this._callbacks.showGeneralError();
        }
    }

    clearErrors() {
        if (this._callbacks !== null) {
            this._callbacks.clearErrors();
        }
    }
}